import { createModal } from './modal.js';

/**
 * One shared gallery modal instance you can reuse for both save & publish.
 * onConfirm receives the selected image key (e.g. 'imgactivity7').
 */
export function createImageSelectModal({ importImgVar, headingText, submitLabel }) {
  let selected = 1;
  let onConfirm = null;

  // imageSelectModal.js — updated buildGallery
  // imageSelectModal.js — buildGallery, hardened against CSS conflicts
  function buildGallery() {
    const wrapper = document.createElement('div');
    wrapper.className = 'image-picker-modal';

    const heading = document.createElement('h4');
    heading.textContent = headingText;
    wrapper.appendChild(heading);

    const grid = document.createElement('div');
    grid.className = 'image-picker-modal__grid';
    // inline, so no external CSS can accidentally override the layout itself
    Object.assign(grid.style, {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fill, minmax(72px, 1fr))',
      gap: '8px',
      maxHeight: '340px',
      overflowY: 'auto',
      padding: '4px',
    });

    for (let i = 1; i <= 28; i++) {
      const img = document.createElement('img');
      img.className = `image-picker-modal__thumb${i === selected ? ' image-picker-modal__thumb--active' : ''}`;
      img.dataset.activeimage = i;
      img.src = importImgVar('imgactivity' + i);
      Object.assign(img.style, {
        width: '100%',
        height: '72px',
        objectFit: 'cover',
        display: 'block',
        borderRadius: '8px',
        cursor: 'pointer',
      });

      img.addEventListener('click', () => {
        selected = i;
        grid.querySelectorAll('.image-picker-modal__thumb').forEach((el) => {
          el.classList.remove('image-picker-modal__thumb--active');
          el.style.border = '2px solid transparent';
          el.style.boxShadow = 'none';
        });
        img.classList.add('image-picker-modal__thumb--active');
        img.style.border = '2px solid var(--modal-teal)';
        img.style.boxShadow = '0 0 0 2px rgba(61, 220, 208, 0.3)';
      });

      grid.appendChild(img);
    }
    wrapper.appendChild(grid);

    const confirmBtn = document.createElement('button');
    confirmBtn.type = 'button';
    confirmBtn.className = 'modal-btn modal-btn--primary';
    confirmBtn.style.marginTop = '16px';
    confirmBtn.textContent = submitLabel;
    confirmBtn.addEventListener('click', () => {
      onConfirm?.('imgactivity' + selected);
      modalApi.close();
    });
    wrapper.appendChild(confirmBtn);

    return wrapper;
  }

  const modalApi = createModal({
    closable: true,
    size: 'lg',
    content: buildGallery,
  });

  // call this right before .open() to say what happens on confirm
  function openFor(confirmHandler) {
    onConfirm = confirmHandler;
    modalApi.open();
  }

  return { ...modalApi, open: openFor };
}
